import cssVariables from './css/navymutual';
import footerHTML from './html/navymutual';
import loginMapper from './utils/loginMapper';

const navymutual = {
  productMap: {
    annuity: 2,
    term: 3,
    disability: 5,
  },
  global: {
    appTitle: 'Navy Mutual',
    favicon: '',
    homepage: '/',
    carrierName: 'Navy Mutual',
    loaderWebm: '/images/animation_loading.webm',
    loaderMp4: '/images/animation_loading.mp4',
    dialogBoxImg: '/images/svg/dialog-box.svg',
    crossMarkImg: '/images/svg/crossMarkImg.svg',
  },
  branding: {
    lightLogo: '/images/svg/navy-mutual-logo.svg',
    darkLogo: '/images/svg/navy-mutual-logo.svg',
    altText: 'Navy Mutual',
  },
  customHeader: {
    isPresent: true,
    banner: {
      padding: '10px',
      color: '#ffffff',
      fontWeight: '500',
    },
  },
  footer: {
    isHTML: true,
    footerHTML,
  },
  theme: {
    cssVars: cssVariables,
    global: {
      colorScheme: '#262d3f',
      background: '#ffffff',
      leftSidebarColor: 'none',
      footerBackground: '#18355E',
      footerTextColor: '#ffffff',
      skipNavigation: {
        button: {
          border: '0px solid transparent',
          selectedBgColor: '#AB1B27',
          bgColor: '#000',
          padding: '2px 12px',
          fontWeight: 'bold',
          outline: 'none !important',
          borderOnFocus: '3px solid #000',
        },
      },
      showPageInfo: true,
      disableBrowserBackButton: true,
      requiredLabelText: 'All fields are required unless otherwise indicated.',
      postDocusignLoadingMessage:
        'Please be patient, we are preparing your policy. This may take a few minutes.',
      globalHeaderTheme: {
        headerPosition: {
          mobile: 'static',
          tablet: 'fixed',
          desktop: 'fixed',
        },
        alignBanner: 'right',
      },
      errorMessageColor: '#AB1B27',
      actualThreshold: 80,
      hideReflexWrapper: true,
      showSignatureLoader: true,
      showOptionalText: true,
      maxChallengeTries: 3,
      customScrollPosition: '-160px',
      customScrollPositionCSR: '-50px',
      breadcrumb: {
        progress: {
          borderRadius: '0px',
          boxShadow: 'none',
          border: '1px solid #262d3f',
          labelColor: '#18355e',
          color: '#AB1B27',
          percentageColor: '#AB1B27',
          percentageFontFamily: 'Avenir-Heavy',
          percentageFontWeight: 'normal',
          progressHeight: '8px',
          progressPendingColor: '#f2efe9',
          progressDoneColor: '#037BB5',
          progressLabelBottom: false,
        },
        active: {
          progressLabelColor: '#18355e',
          titleColor: '#AB1B27',
          background: '#ffffff',
          imageOpacity: '1',
          border: '1px solid #262d3f',
          boxShadow: '4px 4px 0px 0px #262d3f',
          showActiveIndicator: true,
        },
        disabled: {
          progressLabelColor: '#262d3f',
          titleColor: '#262d3f',
          background: '#e6e8ea',
          imageOpacity: '0.5',
          border: '1px solid #262d3f',
        },
      },
      updateButton: {
        themeConfiguration: {
          bgColor: '#ffffff',
          selectedBgColor: '#AB1B27',
          border: '4px solid transparent !important',
          borderOnFocus: '4px solid #037BB5',
          borderRadius: '0px',
          outline: 'none',
          padding: '5px 0',
        },
      },
      removeButton: {
        themeConfiguration: {
          padding: '4px 0px 0px 0px',
          selectedBgColor: 'rgb(69, 137, 255)',
          margin: '0px 20px 0px 0px',
          buttonBorder: '3px solid transparent',
          borderOnFocus: '3px solid black',
          borderBottom: '3px solid black',
        },
      },
      logoutButton: {
        themeConfiguration: {
          selectedBgColor: 'rgb(69, 137, 255)',
          border: '1px solid rgb(69, 137, 255)',
          buttonBorder: '3px solid transparent',
          borderOnFocus: '3px solid black',
        },
      },
      prevButtonTheme: {
        themeConfiguration: {
          linkBtnTheme: {
            bgColor: '#ffffff',
            selectedBgColor: '#AB1B27',
            border: '1px solid #ffffff',
            borderRadius: '0px',
            padding: '7px 20px 7px 20px',
            disabledPadding: '7px 20px 7px 20px',
            borderOnFocus: '2px solid #037BB5',
            shape: 'rectangle',
            transition: '0.05 all',
            disabledTheme: {
              selectedBgColor: '#ffffff',
              bgColor: '#869099',
              border: '1px solid transparent',
            },
            textDecoration: 'none',
            textDecorationColor: '#AB1B27',
          },
          arrowBtnTheme: {
            bgColor: '#ffffff',
            selectedBgColor: 'rgb(38, 45, 63)',
            border: 'none',
            borderRadius: '0px',
            padding: '7px 20px 7px 20px',
            disabledPadding: '7px 20px 7px 20px',
            borderOnFocus: '2px solid #037BB5',
            shape: 'rectangle',
            disabledTheme: {
              selectedBgColor: '#ffffff',
              bgColor: '#869099',
            },
            showDoubleLeftIcon: true,
            disabledPointer: 'default',
            iconTheme: {
              disabledTheme: {
                bgColor: '#869099',
              },
              bgColor: '#AB1B27',
              fontSize: '40px',
              margin: '0px 10px 5px 0px',
            },
          },
          type: 'filled',
        },
      },
      toolTip: {
        color: '#262d3f',
        font: '18px Avenir-Book',
      },
      nextButtonTheme: {
        themeConfiguration: {
          bgColor: 'rgb(38, 45, 63)',
          selectedBgColor: '#ffffff',
          border: '1px solid #00c39c',
          padding: '7px 0 7px 20px',
          disabledPadding: '7px 0 7px 20px',
          disabledPointer: 'default',
          margin: '0px',
          focusMargin: '0px',
          borderRadius: '0px',
          borderOnFocus: '2px solid #037BB5',
          shape: 'rectangle',
          showDoubleRightIcon: true,
          disabledTheme: {
            selectedBgColor: '#ffffff',
            bgColor: '#505B5E',
          },
          iconTheme: {
            disabledTheme: {
              bgColor: '#505B5E',
            },
            bgColor: '#AB1B27',
            fontSize: '40px',
            margin: '0px 0px 5px 10px',
          },
        },
        type: 'filled',
      },
      listButtonsTheme: {
        editButtonTheme: {
          themeConfiguration: {
            bgColor: '#AB1B27',
            selectedBgColor: '#ffffff',
            buttonBorder: '3px solid transparent',
            borderOnFocus: '3px solid #037BB5',
            border: 'none',
            disabledTheme: {
              selectedBgColor: '#ffffff',
              bgColor: '#869099',
            },
          },
        },
        deleteButtonTheme: {
          themeConfiguration: {
            bgColor: '#AB1B27',
            selectedBgColor: '#ffffff',
            buttonBorder: '3px solid transparent',
            borderOnFocus: '3px solid #037BB5',
          },
        },
        closeButtonTheme: {
          themeConfiguration: {
            bgColor: '#AB1B27',
            selectedBgColor: '#ffffff',
            borderOnFocus: '4px solid #037BB5',
          },
        },
        listItemAddButtonTheme: {
          themeConfiguration: {
            bgColor: '#AB1B27',
            selectedBgColor: '#ffffff',
            outline: 'none !important',
            border: '4px solid transparent',
            borderOnFocus: '4px solid #037BB5',
            'text-decoration': 'underline',
            disabledTheme: {
              selectedBgColor: '#ffffff',
              bgColor: '#869099',
            },
          },
        },
        addListItemDashedButton: {
          border: '3px dashed #869099',
          padding: '14px 18px',
          color: '#AB1B27',
          'font-size': '18px',
          'font-family': 'Avenir-Heavy',
          'font-weight': 'normal',
          'text-decoration': 'underline',
          borderOnFocus: '3px solid #037BB5',
          borderRadiusOnFocus: '0px',
          disabledTheme: {
            color: '#869099',
          },
        },
        borderOnFocus: '3px solid #037BB5',
      },
      listItemCardTheme: {
        themeConfiguration: {
          selectedBgColor: '#AB1B27',
          border: '4px solid transparent',
          borderRadius: '0px',
          padding: '5px 15px',
          disabledPadding: '5px 15px',
          disabledPointer: 'default',
          fontSize: '18px',
          fontFamily: 'Avenir-Heavy',
          fontWeight: 'normal',
          borderOnFocus: '4px solid #037BB5',
          outline: 'none !important',
          textDecoration: 'underline',
          disabledTheme: {
            selectedBgColor: '#ffffff',
            bgColor: '#505B5E',
          },
        },
      },
      commonButtonTheme: {
        shape: 'parallelogram',
        disabledPointer: 'default',
        ariaLiveMode: 'live',
        border: '1px solid transparent',
        borderOnFocus: '3px solid #037BB5',
        fontFamily: 'Avenir-Heavy',
        transition: '0.05 all',
        disabledTheme: {
          selectedBgColor: '#f7f7f8',
          bgColor: '#262D3F',
          border: '1px solid transparent',
        },
        hover: {
          selectedBgColor: '#ffffff',
          bgColor: '#AB1B27',
          border: '1px solid #AB1B27',
        },
      },
      modalButton: {
        themeConfiguration: {
          shape: 'parallelogram',
          bgColor: '#ffffff',
          selectedBgColor: '#AB1B27',
          padding: '10px 20px',
          disabledPadding: '10px 20px',
          fontFamily: 'Avenir-Heavy',
          border: '1px solid transparent',
          borderOnFocus: '4px solid #037BB5',
          disabledPointer: 'default',
        },
      },
      modal: {
        questionBlock: {
          border: '1px solid #ccc',
          selectedBorder: '2px solid #18355E',
          borderOnFocus: '3px solid #037BB5',
          circleBgColor: '#F2EFE9',
          selectedCircleBgColor: '#18355E',
        },
      },
      reactSelect: {
        selectLabel: {
          color: '#262d3f',
          fontSize: '18px',
          lineHeight: '21px',
          fontWeight: 'bold',
          font: '18px Avenir-Book',
          labelTooltipAlign: 'left',
          padding: '0.5em 0 0.5em 0',
          marginRight: '10px',
        },
        labelWrapperStyles: {
          alignItems: 'baseline',
        },
        selectedBgColor: '#18355E',
        border: '4px solid transparent',
        focusColor: '#d4d4d4',
        borderRadius: '4px',
        borderOnFocus: '4px solid #037BB5',
        borderRadiusOnFocus: '4px',
        disabledPointer: 'default',
        placeholder: {
          color: '#262d3f',
        },
        zIndex: 2147483641,
      },
      primaryButton: {
        shape: 'oval',
        color: 'white',
      },
      text: {
        headingColor: '#262d3f',
        labelColor: '#262d3f',
        questionTextColor: '#262d3f',
        questionDescriptionColor: '#262d3f',
        sectionHeaderColor: '#262d3f',
      },
      checkboxTheme: {
        themeConfiguration: {
          bgColor: '#ffffff',
          errorMessageColor: '#AB1B27',
          checkedBg: '#18355E',
          fontColor: '#262d3f',
          font: '18px Avenir-Book',
          border: '1px solid #262d3f',
          borderOnFocus: '3px solid #037BB5',
          outlineOffset: '1px',
          borderRadiusOnFocus: '4px',
          disabledPointer: 'default',
          disabledTheme: {
            bgColor: '#E6E8EA',
            border: '1px solid #262d3f',
          },
          labelMargin: '0.5em 0.5em 0.5em 0px',
        },
      },
      radioTheme: {
        fontSize: '18px',
        fontWeight: 'bold',
        checkedBg: '#18355E',
        checkedFg: '#ffffff',
        fillBg: '#aaaaaa',
        fontColor: '#262d3f',
        errorMessageColor: '#AB1B27',
        border: '1px solid #18355E',
        outline: true,
        outlineOnFocus: '4px solid #037BB5',
        outlineOffset: '1px',
      },
      classicRadioTheme: {
        fontWeight: 'normal',
        height: 'auto',
        lineHeight: 1.5,
        margin: '10px',
        alignClassic: 'flex-start',
      },
    },
    components: {
      input: {
        floatingLabel: false,
        labelPosition: 'top',
        labelIsHTML: true,
        width: 'L',
        preTextLeftPadding: '0px',
        themeConfiguration: {
          border: '1px solid #869099',
          font: '18px Avenir-Book',
          labelText: {
            color: '#262d3f',
          },
          labelWrapperStyles: {
            alignItems: 'baseline !important',
          },
          shouldFocusWithin: true,
          borderOnFocus: '#037BB5',
          borderRadiusOnFocus: '4px',
          labelTooltipAlign: 'left',
          tooltipPopperOffsetLeftPos: -150,
          disabledPointer: 'default',
          allowDisabledOpacity: true,
          inputStyles: {
            fontSize: '18px',
            fontFamily: 'Avenir-Book',
            fontColor: '#262d3f',
          },
          placeHolder: {
            color: '#262d3f',
            fontSize: '18px',
            fontFamily: 'Avenir-Book',
          },
        },
      },
      'autocomplete-text': {
        floatingLabel: false,
        labelPosition: 'top',
        labelIsHTML: true,
        width: 'L',
        themeConfiguration: {
          inputBorder: '3px solid transparent',
          shouldFocusWithin: true,
          borderOnFocus: '3px solid black',
        },
      },
      selectOption: {
        floatingLabel: false,
        labelPosition: 'top',
        labelIsHTML: true,
        width: 'L',
        disableCapitalization: true,
        disabledPointer: 'default',
        tooltipPopperOffsetLeftPos: -150,
        disabledTheme: {
          backgroundColor: '#fafafa',
          borderColor: '#869099',
          selectedColor: '#333333',
        },
      },
      singleSelect: {
        shapeOverride: {},
        width: 'L',
        floatingLabel: false,
        labelIsHTML: true,
        labelPosition: 'top',
        shape: 'rectangle',
        overlap: false,
        labelMargin: '0 !important',
        labelFont: '18px',
        removeMargin: true,
        customPadding: '17px 20px',
        transition: 'none',
        font: '18px Avenir-Book',
        disabledPointer: 'default',
        tooltipPopperOffsetLeftPos: -150,
      },
      multiSelect: {
        width: 'L',
        floatingLabel: false,
        labelIsHTML: true,
        labelPosition: 'top',
        removeMargin: true,
        customPadding: '17px 20px',
        disabledPointer: 'default',
        tooltipPopperOffsetLeftPos: -150,
      },
      datepicker: {
        width: 'L',
        floatingLabel: false,
        labelIsHTML: true,
        labelPosition: 'top',
        showPopper: true,
        guide: true,
        isDateChange: true,
        trackCalendarPopper: true,
        showWCAGCloseBtn: true,
        disabledPointer: 'default',
        maskOverwrite: false,
        tooltipPopperOffsetLeftPos: -150,
      },
      card: {
        padding: '20px 0 0',
        showLeftBorder: false,
        isCollapsible: false,
      },
      banner: {
        themeConfiguration: {
          borderRadius: '8px',
          padding: '30px',
          marginLeft: '0px',
        },
        buyNowButton: {
          themeConfiguration: {
            selectedBgColor: '#2865cc',
            bgColor: '#ffffff',
            border: '2px solid white',
            fontColor: '#333333',
            fontWeight: 'bold',
            fontSize: '18px',
            padding: '12px 14px',
            lineHeight: '20px',
            borderOnFocus: '2px solid white',
            margin: '14px 0 0 0',
          },
        },
      },
    },
    pageOverrides: {
      quote: {
        showActiveIndicator: true,
        headingsVerticalSpace: '30px',
        accordionTheme: {
          selectedBgColor: '#FFF',
          bgColor: '#18355E',
          width: '100%',
          alignment: 'left',
          fontWeight: 'bold',
          padding: '0',
          border: 'none',
          mobile: {
            headerTitlePadding: '5px 5px',
            padding: '5px 0',
            fontSize: '14px',
            margin: '0',
            width: 'calc(100% - 35px)',
          },
          borderOnFocus: '4px solid #037BB5',
          outline: 'none !important',
        },
        fullWidthButton: {
          flexDirection: 'column',
          alignItems: 'flex-start',
          btnWidth: '340px',
          margin: '0px auto 15px auto',
          maxWidth: '780px',
          themeConfiguration: {
            selectedBgColor: '#AB1B27',
            bgColor: '#ffffff',
            padding: '10px 20px',
            disabledPadding: '10px 20px',
            fontFamily: 'Avenir-Heavy',
            border: '1px solid transparent',
            borderOnFocus: '4px solid #037BB5',
            disabledPointer: 'default',
            outline: 'none !important',
          },
        },
        icons: {
          'Quote.NeedsCalcLabel': {
            src: '/images/svg/calculator.svg',
            theme: {
              mobile: {
                padding: '0 10px 5px 0',
                border: 'none',
              },
              padding: '0 15px 5px 0',
              border: 'none',
            },
          },
        },
        allowSectionScroll: true,
        buttonDescriptionTheme: {
          color: '#262d3f',
          font: '12px Avenir-Book',
          margin: '15px 0',
          'line-height': '1.5',
        },
      },
      plan: {
        singleSelect: {
          shape: 'card_button',
          removeMargin: true,
          cardButtonTheme: {
            width: '100%',
            selectedBgColor: '#AB1B27',
            bgColor: '#ffffff',
            fontWeight: 900,
            fontSize: '18px',
            padding: '10px 5px',
            border: '4px solid transparent',
            borderRadius: '3px',
            borderOnFocus: '4px solid #ffffff',
            borderOnFocusDesktop: '4px solid #ffffff',
            borderOnFocusMobile: '4px solid #037BB5',
            outline: 'none !important',
          },
          themeConfiguration: {
            outlineOnFocus: '4px solid #AB1B27',
            selectedBgColor: '#18355E',
            outline: false,
          },
        },
        card: {
          themeConfiguration: {
            maxWidth: '870px !important',
            width: '100%',
            margin: 'auto',
          },
          groupMarginBottom: '0px',
        },
        selectOption: {
          floatingLabel: false,
          labelPosition: 'top',
          labelIsHTML: true,
          disableCapitalization: true,
          width: {
            tablet: '220px',
            desktop: '300px',
          },
        },
      },
      quotereview: {
        button: {
          width: '150%',
          shape: 'rounded',
          type: 'outlined',
          color: 'blue',
        },
        input: {
          width: 'M',
          floatingLabel: false,
          labelPosition: 'top',
          labelIsHTML: false,
        },
      },
      signature: {
        is_next_btn_hidden: false,
        is_prev_btn_hidden: true,
        hideTooltipWrapper: true,
        groupTheme: {
          fontSize: '26px',
          fontWeight: 'normal !important',
          fontFamily: 'Avenir-Heavy',
        },
        globalHeaderTheme: {
          headerPosition: {
            mobile: 'static',
            tablet: 'fixed',
            desktop: 'fixed',
          },
          alignBanner: 'right',
        },
        rightContentTheme: {
          width: '90%',
        },
        padding: '5px 10px',
        card: {
          themeConfiguration: {
            maxWidth: '980px !important',
          },
        },
        pdfTheme: {
          hidePageLabel: true,
          skipScrollCheck: true,
          maxHeight: '350px',
          borderOnFocus: '4px solid #00524D',
        },
        labelTheme: {
          fontSize: '18px !important',
          fontWeight: 'normal !important',
          fontFamily: 'Avenir-Book !important',
        },
        zoomButtonsTheme: {
          selectedBgColor: '#262d3f',
        },
        fullWidthButton: {
          flexDirection: 'column',
          alignItems: 'flex-start',
          btnWidth: '256px',
          margin: '0px auto 15px auto',
          maxWidth: '780px',
          themeConfiguration: {
            selectedBgColor: '#AB1B27',
            bgColor: '#ffffff',
            padding: '10px 20px',
            disabledPadding: '10px 20px',
            fontFamily: 'Avenir-Heavy',
            border: '1px solid transparent',
            borderOnFocus: '4px solid #037BB5',
            disabledPointer: 'default',
            outline: 'none !important',
          },
        },
      },
      challenge: {
        card: {
          themeConfiguration: {
            maxWidth: '980px !important',
            width: '100%',
          },
        },
        fullWidthButton: {
          flexDirection: 'column',
          alignItems: 'flex-start',
          btnWidth: '256px',
          margin: '0px auto 15px auto',
          maxWidth: '780px',
          themeConfiguration: {
            selectedBgColor: '#AB1B27',
            bgColor: '#ffffff',
            padding: '10px 20px',
            disabledPadding: '10px 20px',
            fontFamily: 'Avenir-Heavy',
            border: '1px solid transparent',
            borderOnFocus: '4px solid #037BB5',
            disabledPointer: 'default',
            outline: 'none !important',
          },
        },
      },
      review: {
        background: 'linear-gradient(rgb(245, 245, 245) 480px, rgb(247, 247, 247) 480px)',
        headerColor: '#262d3f',
        card: {
          themeConfiguration: {
            padding: '20px 0 0',
            showLeftBorder: false,
            isCollapsible: false,
            marginRight: '3vw',
            imageWidth: '40px',
          },
        },
        breadcrumbHeaderFont: '30px',
        breadcrumbHeaderFontWeight: '600',
        listItemCardTheme: {
          body: {
            padding: '0px',
          },
          text: {
            color: '#262d3f',
            fontSize: '18px',
            cursor: 'default',
            'font-weight': '300',
          },
          hideEditDeleteButtons: true,
          hideAccordion: true,
        },
        fullWidthButton: {
          justifyContent: 'end',
          gap: '10px',
          alignItems: 'flex-end',
          btnWidth: '256px',
          margin: '0px auto 15px auto',
          maxWidth: '75%',
          themeConfiguration: {
            selectedBgColor: '#AB1B27',
            bgColor: '#ffffff',
            padding: '10px 20px',
            disabledPadding: '10px 20px',
            fontFamily: 'Avenir-Heavy',
            border: '1px solid transparent',
            borderOnFocus: '4px solid #037BB5',
            disabledPointer: 'default',
            outline: 'none !important',
          },
        },
      },
      knockout: {
        maxWidth: '100%',
        card: {
          themeConfiguration: {
            height: 'calc(100% - 120px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          themeConfigurationMobile: {
            height: 'calc(100% - 120px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
          },
        },
      },
      login: {
        globalHeaderTheme: {
          headerPosition: {
            mobile: 'static',
            tablet: 'fixed',
            desktop: 'fixed',
          },
          alignBanner: 'right',
        },
        fullWidthButton: {
          flexDirection: 'column',
          alignItems: 'center',
          btnWidth: '150px',
          margin: '0 auto',
          maxWidth: '150px',
          themeConfiguration: {
            selectedBgColor: '#AB1B27',
            bgColor: '#ffffff',
            padding: '10px 20px',
            disabledPadding: '10px 20px',
            fontFamily: 'Avenir-Heavy',
            border: '1px solid transparent',
            borderOnFocus: '4px solid #037BB5',
            disabledPointer: 'default',
            outline: 'none !important',
          },
        },
      },
      q: {
        fullWidthButton: {
          flexDirection: 'column',
          alignItems: 'flex-start',
          btnWidth: '256px',
          margin: '0px auto 15px auto',
          maxWidth: '780px',
          themeConfiguration: {
            selectedBgColor: '#AB1B27',
            bgColor: '#ffffff',
            padding: '10px 20px',
            disabledPadding: '10px 20px',
            fontFamily: 'Avenir-Heavy',
            border: '1px solid transparent',
            borderOnFocus: '4px solid #037BB5',
            disabledPointer: 'default',
            outline: 'none !important',
          },
        },
      },
      questions: {
        showDivider: true,
        showActiveIndicator: true,
        listItemCardTheme: {
          body: {
            padding: '0px',
            background: '#f7f7f8',
            borderRadius: '0px',
          },
          text: {
            color: '#262d3f',
            padding: '0 20px',
            fontSize: '18px',
            cursor: 'default',
            'font-weight': '300',
            width: '90%',
          },
          customAccordion: true,
          editLinkTheme: {
            color: '#262D3F',
            fontSize: '18px',
            fontWeight: 'normal',
            fontFamily: 'Avenir-Heavy',
            border: '4px solid transparent',
            borderOnFocus: '4px solid #037BB5',
            textDecoration: 'underline',
          },
          deleteLinkTheme: {
            color: '#AB1B27',
            fontSize: '18px',
            fontWeight: 'normal',
            fontFamily: 'Avenir-Heavy',
            label: 'Delete',
            border: '4px solid transparent',
            borderOnFocus: '4px solid #037BB5',
            textDecoration: 'underline',
          },
        },
        fieldSetTheme: {
          row: {
            justifyContent: 'flex-start',
          },
          label: {
            color: '#262d3f',
            width: '50%',
            'font-size': '18px',
            'font-weight': '300',
          },
          value: {
            color: '#262d3f',
            width: '50%',
            'font-size': '18px',
            'font-weight': '300',
            'margin-left': '30px',
            'word-break': 'break-all',
          },
        },
      },
      inactivesession: {
        padding: '40px 0',
      },
    },
  },
  layout: {
    quote: 'quote',
    loader: 'single',
    questions: 'double',
    review: 'single',
    quoteResults: 'single',
    quotereview: 'single',
    plan: 'plan',
    'e-signature': 'e-signature',
    signature: 'signature',
    payment: 'single',
    timeout: 'single',
    challenge: 'challenge',
    completed: 'completed',
    products: 'single',
    static: 'single',
    knockout: 'knockout',
    inactivesession: 'inactivesession',
  },
  features: {
    login: loginMapper,
    identityCheck: {
      enable: true,
      pages: ['', 'quote', 'plan', 'questions', 'review', 'challenge', 'signature', 'e-signature'],
    },
  },
  needHelpPopupDialog: {
    title: 'Contact us for assistance.',
    content: 'Our representatives can be reached at the number below during our business hours.',
    phoneNumber: '1-888-300-9331',
    consultationButton: 'Schedule a Consultation',
    sheduleConsultationUrl: 'https://www.navymutual.org/services/schedule-a-consultation-dtc/',
    instructions: 'To continue with this application unassisted, you may close this pop-up window.',
  },
};

export default navymutual;
